import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { list } from 'actions/data'
import LinearProgress from '@material-ui/core/LinearProgress'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import lodash from 'lodash'
const mapStateToProps = state => ({
  bulkUploads: state.data['upload/status/contacts']
})

const mapDispatchToProps = dispatch => bindActionCreators({
  list,  
}, dispatch)

const styles = theme => ({

})

class BulkUploadStatus extends Component {
  state = {
    open: true,
    closeOverride:true
  }
  
  componentDidMount = () => {
    this.props.list('upload/status/contacts', 'upload_id')   
  }

  handleClick = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false, });
    this.props.hideIt()
  };
  render() { 
    const {bulkUploads} = this.props
    console.log("BULKUPLOADS", bulkUploads)
    const bulkUploads_arr = Object.values(bulkUploads ? bulkUploads : {})
    const we_are_Still_processing_a_file = Boolean(lodash.find(bulkUploads_arr, { job_status: "processing_started"}))
    console.log("we_are_Still_processing_a_file", we_are_Still_processing_a_file)
    const Uploads = bulkUploads_arr.map(upload =><div>
      {upload.file_name} - {upload.job_status}
    </div>)
    return (
      
      <Dialog
        
        open={this.state.open}
        aria-labelledby="responsive-dialog-title"
        style={{ borderRadius: 22 }}
      >
      <DialogTitle>Your Bulk Uploads</DialogTitle>
        <DialogContent>
          <div>
            {Uploads}
          </div>
          {we_are_Still_processing_a_file ? <LinearProgress /> : null}
        </DialogContent>
        <DialogActions>

          <Button onClick={this.handleClose} color="secondary">
            Close
                            </Button>
         
        </DialogActions>
      </Dialog>

    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(BulkUploadStatus))
